import { showSuccess, showError } from "../utils/notifications";
import { useState } from "react";
import { OcrConfig } from "../services/csvSettingsService";
import { analyzeSampleFile } from "../services/ocrService";
import { fileToBase64 } from "../utils/fileUtils";

export function useCsvSampleAnalysis(activeOcrConfig?: OcrConfig) {
  // サンプル解析用
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [analyzing, setAnalyzing] = useState(false);
  const [analysisResult, setAnalysisResult] = useState<Record<string, unknown> | null>(null);
  const [analysisPromptUsed, setAnalysisPromptUsed] = useState<string | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [errorDate, setErrorData] = useState<string | null>(null);

  const handleFileSelect = (file: File | null) => {
    if (!file) {
      setSelectedFile(null);
      setPreviewUrl(null);
      setAnalysisResult(null);
      setErrorData(null);
      return;
    }

    setSelectedFile(file);
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    // ファイル変更時は結果とエラーをリセット
    setAnalysisResult(null);
    setErrorData(null);
  };

  const executeAnalysis = async () => {
    if (!selectedFile) return;

    setAnalyzing(true);
    setAnalysisResult(null);
    setAnalysisPromptUsed(null);
    setErrorData(null);

    try {
      const base64 = await fileToBase64(selectedFile);
      const data = await analyzeSampleFile({
        fileBase64: base64,
        mimeType: selectedFile.type,
        fileName: selectedFile.name,
        additionalPrompt: activeOcrConfig?.promptAddition,
      });

      if (data.success) {
        setAnalysisResult(data.result.structuredData);
        setAnalysisPromptUsed(data.result.promptUsed || null);
        showSuccess("伝票の項目抽出に成功しました", "解析完了");
      }
    } catch (error: unknown) {
      console.error("Analysis failed:", error);
      const msg = error instanceof Error ? error.message : "解析に失敗しました";
      setErrorData(msg);
      showError(msg, "解析エラー");
    } finally {
      setAnalyzing(false);
    }
  };

  return {
    selectedFile,
    analyzing,
    analysisResult,
    analysisPromptUsed,
    previewUrl,
    errorDate,
    handleFileSelect,
    executeAnalysis,
  };
}
